import React, { createContext, ReactNode, useContext } from "react";

import { IRentalCostCentreApprovalService } from "../types/services/rental-cost-centre-approval-service";

const RentalCostCentreApprovalServiceContext =
  createContext<IRentalCostCentreApprovalService>(undefined as any);

interface CostCentreApprovalServiceProviderProps {
  service: IRentalCostCentreApprovalService;
  children: ReactNode;
}

function RentalCostCentreApprovalServiceProvider(
  props: CostCentreApprovalServiceProviderProps,
) {
  const { service, children } = props;

  return (
    <RentalCostCentreApprovalServiceContext.Provider value={service}>
      {children}
    </RentalCostCentreApprovalServiceContext.Provider>
  );
}

function useRentalCostCentreApprovalService() {
  return useContext(RentalCostCentreApprovalServiceContext);
}

export {
  RentalCostCentreApprovalServiceProvider,
  useRentalCostCentreApprovalService,
};
